import React, { Component, PropTypes } from "react"
import { Table, Row } from "antd"
import Moment from "moment"
import { observer, inject } from "mobx-react"
import folderIcon from "app/styles/images/sp/folder.svg"
import WarningTip from "app/components/normal/WarningTip/WarningTip"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"
import Highlighter from "app/components/normal/HighLighter"
import highlightable from "app/utils/highlightable"
import { withRouter } from 'react-router-dom'
import queryString from "query-string"

const ObserverFamilyName = observer(({ record, _this, store }) => {
  const { editedHistory } = _this.state
  const { list: { queryMap: { keywords } } } = store
  const tip = (
    <MaterialTip
      overlayClassName="ellipsis-tip"
      title={record.name}
    >
      <Highlighter
        highlightClassName="lightlight"
        highlightStyle={{ fontWeight: "normal" }}
        searchWords={highlightable(record.name, keywords) ? [record.name] : []}
        textToHighlight={record.name}
      />
    </MaterialTip>
  )

  return (
    record.hasHistory
      ? (
        <Row
          onClick={() => _this.openDetail(record)}
          className="family-name cursor-p"
          type="flex"
          justify="start"
          align="middle"
        >
          <img className="folder-icon" src={folderIcon} alt="" />
          <WarningTip
            type="warningTip"
            text={tip}
            justify="start"
            mainKeys={["versionNum", "name", "createTime"]}
            historyData={editedHistory}
            onVisibleChange={(visible) => _this.toggleHistory(visible, record)}
          />
        </Row>
      )
      : (
        <div className="cursor-p" onClick={() => _this.openDetail(record)}>
          <img className="folder-icon" src={folderIcon} alt="" />
          <Highlighter
            highlightClassName="lightlight"
            highlightStyle={{ fontWeight: "normal" }}
            searchWords={highlightable(record.name, keywords) ? [record.name] : []}
            textToHighlight={record.name}
          />
        </div>
      )
  )
})

@inject('auth') @observer
class Index extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      showEditModal: false,
      editedHistory: [],
      name: "",
    }

    this.columns = []
  }

  componentWillReceiveProps(nextProps) {
    const { location } = this.props
    const { location: nextLocation } = nextProps

    if (nextLocation.search !== location.search) {
      if (nextLocation.search) {
        this.loadLimitedData(queryString.parse(nextLocation.search))
      } else {
        this.loadAllData()
      }
    }
  }

  componentDidMount() {
    let { location } = this.props
    if (location.search) {
      this.loadLimitedData(queryString.parse(location.search))
    } else {
      this.loadAllData()
    }
  }

  loadAllData() {
    const { store: { list } } = this.props
    list.getTableData()
      .then(
        res => {
          list.updateTableData(res)
          list.initPageIndex()
        }
      )
  }

  loadLimitedData(queryObj) {
    this.props.store.list.filterData(queryObj)
  }

  openDetail = (record) => {
    const { match, history } = this.props
    history.push(`${match.url}/${record.id}`)
  }

  onPaginChange = selectedPageNumber => {
    let {
      store: {
        list
      },
    } = this.props

    list.changePagin(selectedPageNumber)

    document.getElementById("contentTop").scrollIntoView(true)
  }

  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.props.store.selectedData = selectedRows
    this.props.store.selectedRowKeys = selectedRowKeys
  }

  render() {
    let {
      store: {
        list: {
          tableData,
          totalCount,
          queryMap,
          currentPageIndex,
        },
        selectedRowKeys
      },
    } = this.props
    const { editedHistory } = this.state
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange
    }
    this.columns = [
      {
        title: (
          <div className="ta-l">家系名称</div>
        ),
        dataIndex: "name",
        render: (title, record, index) => {
          return (
            <ObserverFamilyName
              record={record}
              store={this.props.store}
              editedHistory={editedHistory}
              _this={this}
            />
          )
        }
      },
      {
        title: (
          <div className="ta-l">账号</div>
        ),
        dataIndex: "username",
        render: (text) => {
          return (
            <div className="ta-l">
              {text || '-'}
            </div>
          )
        }
      },
      {
        title: (
          <div className="ta-l">账户名</div>
        ),
        dataIndex: "ownerName",
        render: (text) => {
          return (
            <div className='ta-l'>
              {text || '-'}
            </div>
          )
        }
      },
      {
        title: (
          <div className="ta-l">应用组名称 </div>
        ),
        dataIndex: "appGroupName",
        render: (text, record) => {
          return (
            <div className="ta-l">{text}</div>
          )
        }
      },
      {
        title: (
          <div className="ta-l">应用名称 </div>
        ),
        dataIndex: "appName",
        render: (text, record) => {
          return (
            <div className="ta-l">{text}</div>
          )
        }
      },
      {
        title: (
          <div className="ta-l">创建时间</div>
        ),
        dataIndex: "createTime",
        render: text => {
          return text ? <div className="ta-l">{Moment(text).format("YYYY-MM-DD HH:mm:ss")}</div> : ""
        }
      }
    ]
    return (
      <div>
        <div className='wrapper-box'>
          <Table
            className="pgd-datamanage-table"
            rowSelection={rowSelection}
            columns={this.columns}
            rowKey={record => record.id}
            dataSource={tableData.slice()}
            pagination={{
              pageSize: queryMap.limit,
              onChange: this.onPaginChange,
              defaultCurrent: 1,
              current: currentPageIndex,
              total: totalCount,
            }}
          >
          </Table>
        </div>
      </div>
    )
  }
}
export default withRouter(Index)



// WEBPACK FOOTER //
// ./src/app/pages/research/pgs/data_manage/containers/DataTable.js